"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react"),i=require("react/jsx-runtime"),a=require("styled-components"),t=require("@plans/lists"),s=require("@vds/utilities"),n=require("@vds/typography"),o=require("@vds/tiles"),l=require("@vds-tokens/core"),d=require("@vds/notifications"),r=require("@vds/breadcrumbs"),p=require("@vds/buttons"),c=require("@vds/accordions"),u=require("@plans/tiles"),m=require("@vds/lists"),g=require("@plans/type-lockups"),x=require("@plans/utilities"),b=require("@vds/carousels"),h=require("@vds/type-lockups");function j(e){return e&&e.__esModule?e:{default:e}}var f=j(a);const y=f.default.div.withConfig({displayName:"Wrapper",componentId:"VDS__sc-1g8qtxj-0"})`
  box-sizing: border-box;
  padding-bottom: ${l.LayoutTokens.space["12X"].value};
  @media (min-width: ${x.breakpoints.tabletSmall.min}) {
    padding-bottom: ${l.LayoutTokens.space["16X"].value};
  }
`,v=f.default.div.withConfig({displayName:"ContentWrapper",componentId:"VDS__sc-1g8qtxj-1"})`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  margin: 0px auto;
  max-width: 1272px;
  padding-left: ${l.LayoutTokens.space["4X"].value};
  padding-right: ${l.LayoutTokens.space["4X"].value};
  padding-top: ${({promo:e})=>e?l.LayoutTokens.space["8X"].value:l.LayoutTokens.space["12X"].value};
  @media (min-width: ${x.breakpoints.tabletSmall.min}) {
    padding-top: ${({promo:e})=>e?l.LayoutTokens.space["12X"].value:l.LayoutTokens.space["16X"].value};
    padding-left: ${l.LayoutTokens.space["5X"].value};
    padding-right: ${l.LayoutTokens.space["5X"].value};
  }
  width: 100%;
`,k=f.default.div.withConfig({displayName:"PromoOuterWrapper",componentId:"VDS__sc-1g8qtxj-2"})`
  display: flex;
  width: 100%;
`,L=f.default.div.withConfig({displayName:"PromoWrapper",componentId:"VDS__sc-1g8qtxj-3"})`
  box-sizing: border-box;
  margin: 0px auto;
  max-width: 1272px;
  padding: ${l.LayoutTokens.space["8X"].value} ${l.LayoutTokens.space["5X"].value} 0;
  width: 100%;
  @media (min-width: ${x.breakpoints.tabletSmall.min}) {
    padding: ${l.LayoutTokens.space["16X"].value}
      ${l.LayoutTokens.space["5X"].value} 0;
  }
`,w=f.default.div.withConfig({displayName:"LeftWrapper",componentId:"VDS__sc-1g8qtxj-4"})`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (min-width: ${x.breakpoints.tabletSmall.min}) {
    width: 100%;
  }
`,T=f.default.div.withConfig({displayName:"RightWrapper",componentId:"VDS__sc-1g8qtxj-5"})`
  display: none;
  @media (min-width: ${x.breakpoints.tabletLarge.min}) {
    padding-left: 40px;
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`,$=f.default.div.withConfig({displayName:"ListWrapper",componentId:"VDS__sc-1g8qtxj-6"})`
  display: flex;
  flex-direction: column;
  @media (min-width: ${x.breakpoints.tabletSmall.min}) {
  }
`,_=f.default.div.withConfig({displayName:"ListTitleWrapper",componentId:"VDS__sc-1g8qtxj-7"})`
  display: flex;
  flex-direction: column;
  gap: ${l.LayoutTokens.space["2X"].value};
  margin-bottom: ${l.LayoutTokens.space["6X"].value};
  @media (min-width: ${x.breakpoints.tabletSmall.min}) {
    margin-bottom: ${l.LayoutTokens.space["8X"].value};
    gap: ${l.LayoutTokens.space["3X"].value};
  }
`,S=f.default.div.withConfig({displayName:"TableWrapper",componentId:"VDS__sc-1g8qtxj-8"})`
  > div {
    border-radius: 24px;
    overflow: auto;
  }
`,X=f.default.div.withConfig({displayName:"ImageListWrapper",componentId:"VDS__sc-1g8qtxj-9"})`
  margin-top: ${l.LayoutTokens.space["4X"].value};
  @media (min-width: ${x.breakpoints.tabletSmall.min}) {
    margin-top: ${l.LayoutTokens.space["6X"].value};
  }
`,q=f.default.div.withConfig({displayName:"AboutTextLinkWrapper",componentId:"VDS__sc-1g8qtxj-10"})`
  margin-top: ${l.LayoutTokens.space["8X"].value};
`,I=f.default.div.withConfig({displayName:"SavingsChartLeftWrapper",componentId:"VDS__sc-1g8qtxj-11"})`
  margin-top: ${l.LayoutTokens.space["12X"].value};
  @media (min-width: ${x.breakpoints.tabletSmall.min}) and (max-width: ${x.breakpoints.tabletSmall.max}) {
    margin-top: ${l.LayoutTokens.space["16X"].value};
  }
  @media (min-width: ${x.breakpoints.tabletLarge.min}) {
    margin-top: 0px;
    display: none;
  }
`,O=f.default.div.withConfig({displayName:"DescriptionWrapper",componentId:"VDS__sc-1g8qtxj-12"})`
  display: flex;
  flex-direction: column;
  padding: ${l.LayoutTokens.space["12X"].value} 0px;
  width: 100%;
  @media (min-width: ${x.breakpoints.tabletSmall.min}) {
    padding: ${l.LayoutTokens.space["16X"].value} 0px;
  }
`,C=f.default.div.withConfig({displayName:"DescriptionTitleBodyWrapper",componentId:"VDS__sc-1g8qtxj-13"})`
  display: flex;
  flex-direction: column;
  gap: ${l.LayoutTokens.space["2X"].value};
  padding-bottom: ${l.LayoutTokens.space["6X"].value};
  width: 100%;
  @media (min-width: ${x.breakpoints.tabletSmall.min}) {
    gap: ${l.LayoutTokens.space["3X"].value};
    padding-bottom: ${l.LayoutTokens.space["8X"].value};
  }
`,D=f.default.div.withConfig({displayName:"ListsWrapper",componentId:"VDS__sc-1g8qtxj-14"})`
  display: flex;
  flex-direction: column;
  gap: ${l.LayoutTokens.space["3X"].value};
  padding-top: ${l.LayoutTokens.space["6X"].value};
`,N=f.default.div.withConfig({displayName:"ListsItemWrapper",componentId:"VDS__sc-1g8qtxj-15"})`
  display: flex;
  flex-direction: column;
`,V=f.default.div.withConfig({displayName:"AccordionWrapper",componentId:"VDS__sc-1g8qtxj-16"})`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (min-width: ${x.breakpoints.tabletSmall.min}) {
  }
`,W=f.default.div.withConfig({displayName:"TableHeaderWrapper",componentId:"VDS__sc-1g8qtxj-17"})`
  > div {
    margin-top: none !important;
  }
`,z=f.default.div.withConfig({displayName:"MediaWrapper",componentId:"VDS__sc-1g8qtxj-18"})`
  border-radius: 24px;
  margin-top: ${l.LayoutTokens.space["12X"].value};
  overflow: hidden;
  width: 100%;
  @media (min-width: ${x.breakpoints.tabletSmall.min}) {
    margin-top: ${l.LayoutTokens.space["16X"].value};
  }
`,B=f.default.div.withConfig({displayName:"BrowseSectionWrapper",componentId:"VDS__sc-1g8qtxj-19"})`
  margin-top: ${l.LayoutTokens.space["12X"].value};
  @media (min-width: ${x.breakpoints.tabletSmall.min}) {
    margin-top: ${l.LayoutTokens.space["16X"].value};
  }
`,A=f.default.div.withConfig({displayName:"BrowseSectionButtonWrapper",componentId:"VDS__sc-1g8qtxj-20"})`
  margin-top: ${l.LayoutTokens.space["6X"].value};
`,G=f.default.div.withConfig({displayName:"CarouselWrapper",componentId:"VDS__sc-1g8qtxj-21"})`
  align-items: center;
  justify-content: center;
  margin: 0px auto;
  max-width: 1272px;
  overflow: hidden;
  padding-bottom: ${l.LayoutTokens.space["8X"].value};
  padding-top: ${l.LayoutTokens.space["12X"].value};
  @media (min-width: ${x.breakpoints.tabletSmall.min}) {
    padding-top: 56px;
    padding-bottom: 0px;
  }
`,M=f.default.div.withConfig({displayName:"ManageLinesWrapper",componentId:"VDS__sc-1g8qtxj-22"})`
  box-sizing: border-box;
  margin: 0px auto;
  max-width: 1272px;
  padding-left: ${l.LayoutTokens.space["4X"].value};
  padding-right: ${l.LayoutTokens.space["4X"].value};
  @media (min-width: ${x.breakpoints.tabletSmall.min}) {
    padding-left: ${l.LayoutTokens.space["5X"].value};
    padding-right: ${l.LayoutTokens.space["5X"].value};
  }
  width: 100%;
`,P=f.default.div.withConfig({displayName:"CarouselItemWrapper",componentId:"VDS__sc-1g8qtxj-23"})`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`,R=f.default.div.withConfig({displayName:"CarouselItemButtonWrapper",componentId:"VDS__sc-1g8qtxj-24"})`
  align-items: end;
  display: flex;
  height: 100%;
  padding-top: ${l.LayoutTokens.space["6X"].value};
  @media (min-width: ${x.breakpoints.tabletSmall.min}) {
    padding-top: ${l.LayoutTokens.space["8X"].value};
  }
`,U=f.default.div.withConfig({displayName:"BreadcrumbsWrapper",componentId:"VDS__sc-1g8qtxj-25"})`
  margin: 0px auto;
  max-width: 1272px;
  padding: ${l.LayoutTokens.space["4X"].value} 0px;
  padding-left: ${l.LayoutTokens.space["4X"].value};
  @media (min-width: ${x.breakpoints.tabletSmall.min}) {
    padding: ${l.LayoutTokens.space["5X"].value} 0px;
    padding-left: ${l.LayoutTokens.space["5X"].value};
  }
`,H=f.default.div.withConfig({displayName:"NotificationBannerWrapper",componentId:"VDS__sc-1g8qtxj-26"})`
  margin: 0px auto;
  max-width: 1272px;
  padding: 0px ${l.LayoutTokens.space["4X"].value}
    ${l.LayoutTokens.space["5X"].value};
  @media (min-width: ${x.breakpoints.tabletSmall.min}) {
    padding: 0px ${l.LayoutTokens.space["5X"].value}
      ${l.LayoutTokens.space["5X"].value};
  }
`,F=f.default.div.withConfig({displayName:"ButtonGroupWrapper",componentId:"VDS__sc-1g8qtxj-27"})`
  display: flex;
  padding-top: ${l.LayoutTokens.space["8X"].value};
`,E=f.default(u.Tile).withConfig({displayName:"StyledTile",componentId:"VDS__sc-1g8qtxj-28"})``,Q=f.default.div.withConfig({displayName:"AccordionLinkWrapper",componentId:"VDS__sc-1g8qtxj-29"})`
  padding-top: ${l.LayoutTokens.space["8X"].value};
`;var J=s.withVDSManager((a=>{const{details:s,savings:x,about:j,browseSection:f,breadcrumbs:J,subscription:K,textLink:Y,accordion:Z,listGroup:ee,carouselData:ie,surface:ae,promo:te,viewport:se,media:ne,hero:oe,notification:le,buttonGroup:de}=a,re=()=>x?i.jsx(u.SavingsTile,Object.assign({surface:ae},x)):null;return i.jsxs(y,{children:[J&&i.jsx(U,{children:i.jsx(r.Breadcrumbs,Object.assign({surface:ae},{children:J&&J.map(((e,a)=>i.jsx(r.BreadcrumbItem,Object.assign({href:e.href},{children:e.children}),a)))}))}),le&&i.jsx(H,{children:i.jsx(d.Notification,Object.assign({surface:ae},le))}),oe&&i.jsx(u.Feature,Object.assign({},oe)),ie&&i.jsx(G,{children:i.jsx(b.Carousel,{slotAlignment:{vertical:"middle"},layout:"mobile"===se?"1UP":"3UP",gutter:"24px",peek:"mobile"===se?"standard":"none",surface:ae,paginationFill:"light",paginationInset:"12px",paginationDisplay:"onHover",aspectRatio:"1:1",data:ie,renderItem:e=>i.jsx(E,Object.assign({surface:ae,height:"100%",borderRadius:"12px",padding:"24px"},{children:i.jsxs(P,Object.assign({surface:ae},{children:[i.jsx(h.TitleLockup,{surface:ae,data:{title:Object.assign({bold:!0,size:"titleSmall"},e.title),subtitle:Object.assign({size:"bodySmall"},e.subtitle)}}),i.jsx(R,{children:i.jsx(p.Button,Object.assign({use:"primary",surface:ae,size:"small"},e.button))})]}))}))})}),ee&&i.jsxs(M,{children:[(null==ee?void 0:ee.title)&&i.jsx(n.Title,Object.assign({color:"light"===ae?l.ColorTokens.palette.black.value:l.ColorTokens.palette.white.value},null==ee?void 0:ee.title)),i.jsx(m.ListGroup,Object.assign({surface:ae,bottomLine:!0},{children:(null==ee?void 0:ee.list)&&ee.list.map(((e,a)=>i.jsxs(m.ListGroupItem,Object.assign({surface:ae},e,{children:[i.jsx(m.ListGroupItemTitle,Object.assign({bold:!0,surface:ae},e.title)),i.jsx(m.ListGroupItemSubtitle,Object.assign({surface:ae},e.subtitle))]}),a)))}))]}),te&&i.jsx(k,{children:i.jsx(L,{children:i.jsx(o.TileContainer,Object.assign({padding:"16px",height:"100%",width:"100%"},te))})}),i.jsxs(v,Object.assign({promo:te},{children:[i.jsxs(w,{children:[s&&i.jsxs($,{children:[s.title&&s.title.children&&i.jsxs(_,{children:[i.jsx(n.Title,Object.assign({size:"large",bold:!0},s.title)),i.jsx(n.Body,Object.assign({size:"large"},s.subtitle))]}),s.table&&(()=>{if(!(null==s?void 0:s.table))return null;return i.jsx(u.Table,Object.assign({surface:ae},null==s?void 0:s.table,{head:{headers:(e=null==s?void 0:s.table.head,e.headers.map((e=>Object.keys(e).length<1?e:{children:i.jsxs(W,{children:[e.children,i.jsx("br",{}),i.jsx(g.Pricing,Object.assign({surface:ae,size:"mobile"===se?"XSmall":"small"},e.pricing))]})})))}}));var e})(),s.list&&i.jsx(X,{children:i.jsx(t.ImageList,Object.assign({size:"large"},s.list))})]}),x&&i.jsx(I,{children:re()}),ne&&i.jsx(z,{children:i.jsx(u.MediaTile,Object.assign({surface:"light",aspectRatio:"mobile"===se?"3:4":"16:9"},ne))}),f&&i.jsxs(B,{children:[f.title&&i.jsx(n.Title,Object.assign({size:"large",bold:!0},f.title)),f.button&&i.jsx(A,{children:i.jsx(p.Button,Object.assign({size:"large",use:"secondary",surface:ae},f.button))})]}),j&&i.jsxs(O,{children:[i.jsxs(C,{children:[j.title&&j.title.children&&i.jsx(n.Title,Object.assign({size:"large",bold:!0},j.title)),j.content&&j.content.children&&i.jsx(n.Body,Object.assign({size:"large"},j.content))]}),j.list&&i.jsx(m.UnorderedList,{children:j.list.map((e=>i.jsx(m.ListItem,Object.assign({size:"bodyLarge",surface:ae},{children:e.children}))))}),j.lists&&i.jsx(m.UnorderedList,{children:j.lists.map((e=>i.jsxs(D,{children:[i.jsx(n.Body,Object.assign({size:"large",bold:!0,surface:ae},{children:e.subtitle})),i.jsx(N,{children:e.content&&e.content.map((e=>i.jsx(m.ListItem,Object.assign({size:"bodyLarge",surface:ae},{children:e.children}))))})]})))}),j.textLink&&i.jsx(q,{children:i.jsx(p.TextLink,Object.assign({type:"standAlone",size:"mobile"===se?"small":"large"},j.textLink))})]}),Z?i.jsxs(V,{children:[Z.title&&i.jsx(n.Title,Object.assign({size:"large",bold:!0},Z.title)),i.jsx(c.Accordion,Object.assign({},Z,{surface:ae},{children:Z.data&&Z.data.map(((a,t)=>e.createElement(c.AccordionItem,Object.assign({},a,{key:`Accordion-item-${t}`}),i.jsxs(c.AccordionHeader,Object.assign({},a.header,{children:[a&&a.header&&a.header.title&&i.jsx(c.AccordionTitle,Object.assign({},a.header.title)),a&&a.header&&a.header.subtitle&&i.jsx(c.AccordionSubTitle,Object.assign({},a.header.subtitle))]})),i.jsx(c.AccordionDetail,Object.assign({},a.details,{children:a&&a.details&&a.details.children})))))})),Z.link&&i.jsx(Q,{children:i.jsx(p.TextLinkCaret,Object.assign({},Z.link))})]}):null,de&&i.jsx(F,{children:i.jsx(p.ButtonGroup,Object.assign({alignment:"left",rowQuantity:{mobile:1,mobileLarge:1}},de))})]}),i.jsx(T,{children:i.jsx(S,{children:re()})})]}))]})}));exports.default=J;
